import { FieldType } from '../../manager/FieldType';
import { Table } from './Table';
import { attributeGroups } from './attributeGroups';
import { toolbox } from './toolbox';
import { FieldTypeManager } from '../../manager/FieldTypeManager';

export const tableFieldType: FieldType = {
  name: 'table',
  component: Table,
  attributeGroups: attributeGroups,
  toolbox,
};

FieldTypeManager.register(tableFieldType.name, tableFieldType);
